import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Resets scroll position on route changes so SPA navigations don't preserve
 * the previous page's scroll offset. If the URL contains a hash anchor, we
 * scroll to that element instead (with a tiny delay so the target node has
 * a chance to mount).
 */
const ScrollToTop = () => {
  const { pathname, hash, key } = useLocation();

  useEffect(() => {
    if (hash) {
      const id = decodeURIComponent(hash.replace(/^#/, ""));

      // Re-attempt the scroll several times over ~2.5s. This handles two
      // things on top of the initial mount: (a) the target section may not
      // exist yet when the page first renders, and (b) async content (like
      // the blog teaser fetching posts) can shift layout after we've already
      // scrolled, leaving the user above the intended anchor.
      const delays = [0, 80, 200, 450, 900, 1500, 2400];
      const timers = delays.map((d) =>
        setTimeout(() => {
          const el = document.getElementById(id);
          if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
        }, d)
      );
      return () => timers.forEach(clearTimeout);
    }
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, [pathname, hash, key]);

  return null;
};

export default ScrollToTop;
